import { useTranslation } from "react-i18next";

import ConfirmDialog from "../../components/ui/confirmDialog";

interface IncomeChangeWarningModalProperties {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}

// "CAPS Warning" popup shown from Save & Exit when the driver/second-signer
// combined gross income has changed since the last save — the change also
// updates the dealer's income + advance calc in Step 2.
function IncomeChangeWarningModal({ open, onOpenChange, onConfirm }: IncomeChangeWarningModalProperties) {
  const { t } = useTranslation();

  return (
    <ConfirmDialog
      open={open}
      onOpenChange={onOpenChange}
      title={t("exit.incomeChangeWarning.title")}
      description={t("exit.incomeChangeWarning.message")}
      icon={<span className="text-warning-foreground text-lg font-bold leading-none">!</span>}
      closeLabel={t("exit.incomeChangeWarning.close")}
      maxWidthClassName="max-w-md"
      variant="warning"
      cancelAction={{ label: t("exit.incomeChangeWarning.no") }}
      confirmAction={{ label: t("exit.incomeChangeWarning.yes"), onClick: onConfirm }}
    />
  );
}

export default IncomeChangeWarningModal;
